import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isObjectEmpty' })
export class IsObjectEmptyPipe implements PipeTransform {
  transform<T>(value: T): boolean {
    if(value === null || value === undefined) {
      return false;
    }
    return typeof value === "object" && Object.keys(value).length > 0;
  }
}
